/** Same rules as the API's `npm run roster:import`: lines without "@" (the header) are skipped, quotes stripped. */
export function parseRoster(text: string): { email: string; participantId?: string }[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.split(/[,;\t]/).map((cell) => cell.trim().replace(/^"|"$/g, "")))
    .filter(([email]) => Boolean(email && email.includes("@")))
    .map(([email, participantId]) =>
      participantId ? { email: email as string, participantId } : { email: email as string },
    );
}
